<div class="read-group-main">
    
    <div class="left-side">
        <h2>Läs in klass</h2>

        <div class="card">
            <div class="card_text">
              <div class="text_info">
               <p>Börja med att läsa in informationen om din klass. Du behöver ladda hem en mall som du hämtar 
                <a href="/assets/klass_mall.xlsm" download="klass_mall.xlsm">HÄR</a>
               </p>
            </div>      
          </div>
        </div>

        <mat-card class="mat-card">
            <mat-card-content>
                <p>När du laddat hem mallen, följ då dessa steg:</p>
               <mat-list role="list">
                <mat-list-item role="listitem">1. Döp om mallen till ett filnamn som accocieras med klassen </mat-list-item>
                <mat-list-item role="listitem">2. Öppna dokumentet på din dator, fyll i data enligt beskrivning </mat-list-item>
                <mat-list-item role="listitem">3. Den .csv fil som du sparat enligt beskrivning i mallen läses sedan in nedan </mat-list-item>
               </mat-list>
            </mat-card-content>
        </mat-card>    

        <mat-card class="mat-card">
            <mat-card-content>
                <input class="input-file" type="file" (change)="onFileSelect($event.target)" name="myfile">
            </mat-card-content>
        </mat-card>

        <mat-card class="mat-card">
            <mat-card-content>
                <h2><b>Information om klassen</b></h2>
                <div class="meas-group">
                    <b><p id="meas-group-item"></p></b>
                </div>
                <div class="meas-num">
                    <b><p id="meas-num-item"></p></b>
                </div>
                <div class="meas-question">
                    <b><p id="meas-question-item"></p></b>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    
    <div class="table-group">
        <ag-grid-angular
            class="ag-theme-alpine"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            rowHeight="35"
            >
        </ag-grid-angular>
    </div>


</div>






